module.exports = "https://www.gc-pro.gnp.com.mx/4331f7162a81db6f9da21d245f2e8b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/facturas/3.png
// module id = 1033
// module chunks = 0 1